module.exports = __webpack_public_path__ + "img/whatsapp.e3808947.svg";